import { ActionMenu } from 'ui/actionMenu';
import { ActionMenuOption, AllowedActionMenuElements, MENU_ALIGNMENTS } from 'ui/actionMenu/types';
import { Edit16, Archive16, Overflow } from 'ui/icons';
import { usePrequelContext } from 'modules/dataSync/contexts/PrequelContext';
import { useDataSyncTranslations } from 'modules/dataSync/hooks/useDataSyncTranslations';
import { useModalContext } from 'utils/contexts/modal';
import { DataSyncModalAction, DataSyncModalState } from 'modules/dataSync/contexts/ModalContext';
import { MenuButton } from './PageHeader.styles';

interface PageActionsProps {
  destinationId: string;
  destinationName: string;
}

export const PageActions = ({ destinationId, destinationName }: PageActionsProps) => {
  const { t } = useDataSyncTranslations();
  const { navigateToEdit } = usePrequelContext();
  const { showModal } = useModalContext<DataSyncModalState>();

  const handleEditDestination = () => {
    navigateToEdit(destinationId);
  };

  const handleArchiveDestination = () => {
    showModal({
      action: DataSyncModalAction.ARCHIVE_DESTINATION,
      payload: {
        destinationId,
        destinationName: destinationName || 'Unknown Destination',
      },
    });
  };

  const overflowOptions: ActionMenuOption[] = [
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <Edit16 height={16} />
          <span>{t('transferHistory.actions.editDestination')}</span>
        </>
      ),
      id: 'edit-destination',
      onClick: handleEditDestination,
    },
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <Archive16 height={16} />
          <span>{t('transferHistory.actions.archiveDestination')}</span>
        </>
      ),
      id: 'archive-destination',
      onClick: handleArchiveDestination,
      isDestructive: true,
    },
  ];

  return (
    <ActionMenu
      align={MENU_ALIGNMENTS.RIGHT}
      options={overflowOptions}
      data-test="destination-transfer-page-actions"
    >
      <MenuButton aria-label="More options">
        <Overflow height={20} width={20} />
      </MenuButton>
    </ActionMenu>
  );
};
